
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_bfeatures';
const tableOfContents = [{
  "title": "Features",
  "slug": "features",
  "children": []
}, {
  "title": "Why Tradly Vs Other Booking Platforms?",
  "slug": "why-tradly-vs-other-booking-platforms",
  "children": []
}, {
  "title": "Is any of the important feature missing?",
  "slug": "is-any-of-the-important-feature-missing",
  "children": []
}, {
  "title": "Pricing",
  "slug": "pricing",
  "children": []
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <_Heading level={2} id={"features"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Features</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Host under your custom domain or hosted under tradly.co subdomain`}</li>
      <li parentName="ul">{`Payments `}</li>
      <li parentName="ul">{`Tickets / Inventory Controls `}</li>
      <li parentName="ul">{`Ticket Variances, so you can have variety of sub-tickets under events`}</li>
      <li parentName="ul">{`Repeated Events. Configure repeat events with a flexible time chooser under the same event, so you don’t need to create different events for different time`}</li>
      <li parentName="ul">{`Granular control on events: Add images, title and description on each event variance level `}</li>
      <li parentName="ul">{`Configure custom SEO`}</li>
    </ul>
    <_Heading level={2} id={"why-tradly-vs-other-booking-platforms"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Why Tradly Vs Other Booking Platforms?</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Multi Account like a marketplace`}</li>
      <li parentName="ul">{`Allow account manager to manage their own events and Profile`}</li>
      <li parentName="ul">{`Unlimited number of events`}</li>
      <li parentName="ul">{`Unlimited staff under your admin panel`}</li>
      <li parentName="ul">{`Unlimited number of users in your platform `}</li>
      <li parentName="ul">{`Video listings `}</li>
      <li parentName="ul">{`Continous improvements of features and releases every quarter`}</li>
      <li parentName="ul">{`Create Collections to group events`}</li>
      <li parentName="ul">{`Create internal promotions to promote specific event or account`}</li>
      <li parentName="ul">{`Developer Focused Headless API and toolkits`}</li>
    </ul>
    <_Heading level={2} id={"is-any-of-the-important-feature-missing"} nextElement={{
      "type": "paragraph"
    }}>Is any of the important feature missing?</_Heading>
    <p>{`Do you think any fundamental feature is missing for you to move forward with Tradly?
Let us know, we are curious to know what it is and add in our Roadmap. `}</p>
    <_Heading level={2} id={"pricing"} nextElement={{
      "type": "paragraph"
    }}>Pricing</_Heading>
    <p>{`Starts with a free pricing and has a fair price increment based on your growth.`}</p>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
